<!-- eslint-disable -->
<template>
  <CommonPages id="loans" :class="['loans']" :titlePrefix="'Auto Loan Lenders'"
    :metaDescription="domainConfig?.['meta']?.des || 'Default des'">
    <div class="loan-lenders"
      :class="[deviceType === 'mobile' ? 'detect_deviece_mobile' : 'detect_deviece_pc']">
      <div class="loan-lenders__header" :class="`design-${domainConfig?.['designType']}`">
        <h1 class="loan-lenders__title">Auto Loan Lenders</h1>
        <!-- <p class="loan-lenders__description">Find the best auto loan options tailored to your needs
          with our trusted lenders.</p> -->
        <div class="loan-lenders__divider"></div>
      </div>

      <!-- <AdComponent v-if="deviceType == 'mobile'"
        v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.all_1" ref="ads-all-1"
        class="ad-width-100 m_padding" :ads="adsensConfig?.all_1" :showDebug="showDebug" /> -->

      <div class="loan-lenders__content">
        <div class="loan-lenders__grid">
          <template v-for="(lender, index) in displayLenders">
            <div :key="index" class="lender-card" @click="goToLenderDetails(lender)">
              <div class="lender-logo-container">
                <div class="lender-logo">
                  <img :src="lender.logoUrl" alt="Lender logo" class="lender-logo" />
                </div>
                <div class="lender-info">
                  <div class="lender-name">{{ lender.name || lender.lender }}</div>
                  <div class="lender-rating">
                    <img src="@/assets/icons/star.svg" alt="Rating" class="star-icon" />
                    <span>{{ lender.rating || (lender.rate ? parseFloat(lender.rate).toFixed(1) : '0') }}</span>
                  </div>
                </div>
              </div>
              <div class="divider"></div>
              <div class="lender-details">
                <div class="detail-item">
                  <div class="detail-icon apr-icon">
                    <img src="@/assets/icons/apr.svg" alt="APR" />
                  </div>
                  <div class="detail-content">
                    <div class="detail-label">APR from</div>
                    <div class="detail-value">{{ lender.apr || lender.aprFrom }}</div>
                  </div>
                </div>
                <div class="detail-item">
                  <div class="detail-icon term-icon">
                    <img src="@/assets/icons/term.svg" alt="Term" />
                  </div>
                  <div class="detail-content">
                    <div class="detail-label">Loan term</div>
                    <div class="detail-value">{{ lender.term || `${lender.loanTerm} mos` }}
                    </div>
                  </div>
                </div>
                <div class="detail-item">
                  <div class="detail-icon amount-icon">
                    <img src="@/assets/icons/amount.svg" alt="Amount" />
                  </div>
                  <div class="detail-content">
                    <div class="detail-label">Loan amount</div>
                    <div class="detail-value">
                      {{ lender.amount || `$${lender.loanAmount}` }}</div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 插入广告 -->
            <div v-if="$global.isObjectNotEmpty(adsensConfig) && shouldInsertAd(index) !== -1"
              :key="`ad_${index}`" class="ad-width-100 ad-pos-row">
              <AdComponent v-if="adsensConfig?.all?.[shouldInsertAd(index)]"
                :ref="'ads-list-' + index" class="recommand-ads"
                :ads="adsensConfig?.all[shouldInsertAd(index)]" :showDebug="showDebug" />
            </div>
          </template>

        </div>
      </div>
    </div>
  </CommonPages>
</template>

<script>
import common from '@/mixin/common.js'
import adMixin from '@/mixin/adMixin.js'
import adTrackingMixin from '@/mixin/adTrackingMixin.js'
import { mapGetters } from 'vuex';
import CommonPages from '@/pages/components/page_common.vue'
import AdComponent from '@/pages/components/AdComponent.vue'
import '@/css/home.scss';
import '@/css/common.scss';

export default {
  name: 'Home',
  components: {
    CommonPages,
    AdComponent
  },
  mixins: [common, adMixin, adTrackingMixin],
  data () {
    return {
      lenders: []
    };
  },
  computed: {
    ...mapGetters([
      "adsensConfig",
      'adPosConfig',
      'deviceType',
      'domainConfig',
      'glossary'
    ]),
    displayLenders () {
      // 如果有API返回的数据，优先使用，否则使用默认数据
      return this.glossary && this.glossary.length > 0 ? this.glossary : this.lenders
    }
  },
  async activated () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[Home] Component activated`);
    }

  },
  async mounted () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[Home] Component mounted`);
    }

    await this.initAdSystem();
    // 确保在广告系统初始化后再初始化跟踪
    this.$nextTick(() => {
      this.initAdTracking();
    });
  },
  deactivated () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[Home] Component deactivated`);
    }
  },
  beforeDestroy () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[Home] Component beforeDestroy`);
    }
  },
  methods: {
    shouldInsertAd (index) {
      // 判断是否应该插入广告的位置
      const position = index + 1;
      const adIndex = this.deviceType == 'mobile' ? this.adPosConfig.listRecommand.indexOf(position) : this.adPosConfig.listRecommandPC.indexOf(position);

      /// 返回广告在 homeAD 中的索引，如果不在配置中则返回 -1
      return adIndex !== -1 ? adIndex : -1;
    },
    // 通用导航方法
    navigateToPage (path) {
      console.log(`navigateToPage: ${path}`);
      // 检查是否存在channel参数
      if (this.$route.params.channel) {
        // 如果有channel参数，使用完整路径
        this.$router.push(`/${this.$route.params.channel}${path}`);
      } else {
        // 如果没有channel参数，直接导航
        this.$router.push(path);
      }
    },
    goToLenderDetails (lender) {
      console.log((lender.name || lender.lender || '').toLowerCase());
      const lenderName = (lender.name || lender.lender || '').toLowerCase().replace(/\s+/g, '-');
      this.$router.push({
        name: 'LenderDetails',
        params: {
          lenderName: lenderName,
          id: lender.id || '1'
        }
      });
    },
  }
};
</script>

<style lang="scss" >
@import '~@/css/variables.scss';

.loan-lenders {
	// padding: rem(60) rem(120);
	position: relative;
	padding-bottom: rem(120);

	&.detect_deviece_mobile {
		padding-bottom: rem(36);
	}

	&__header {
		display: flex;
		width: 100%;
		height: rem(200);
		flex-direction: column;
		align-items: center;
		margin-bottom: rem(40);
		text-align: center;
		gap: rem(20);
		justify-content: center;
		.detect_deviece_mobile & {
			margin-bottom: rem(30);
			padding: rem(42) rem(16);
			height: fit-content;
		}

		&.design-1 {
			background: url('~@/assets/auto-loan-bg.png') no-repeat center center;
			background-size: cover;
		}
		&.design-2 {
			background: url('~@/assets/auto-loan-bg-2.png') no-repeat center center;
			background-size: cover;
		}

		.detect_deviece_mobile & {
			&.design-1 {
				background: url('~@/assets/auto-loan-bg-m.png') no-repeat center center;
				background-size: cover;
			}
			&.design-2 {
				background: url('~@/assets/auto-loan-bg-m-2.png') no-repeat center center;
				background-size: cover;
			}
		}
	}

	&__title {
		color: #fff;
		font-size: rem(32);
		line-height: rem(36);
		font-weight: 900;

		.detect_deviece_mobile & {
			font-size: rem(24);
			line-height: rem(28);
			margin-bottom: rem(12);
		}
	}

	&__description {
		color: #fff;
		font-size: rem(16);
		line-height: rem(20);
		font-weight: 400;
		max-width: rem(700);

		.detect_deviece_mobile & {
			font-size: rem(14);
			line-height: rem(18);
			margin-bottom: rem(20);
		}
	}

	&__divider {
		width: rem(36);
		height: rem(4);
		background-color: #fff;
		border-radius: rem(100);
		background: #fff;
	}

	&__content {
		margin-top: rem(40);
		padding: 0 rem(120);

		.detect_deviece_mobile & {
			padding: 0 rem(16);
			margin-top: rem(20);
		}
	}

	&__grid {
		display: flex;
		flex-wrap: wrap;
		gap: rem(28) rem(30);

		.detect_deviece_mobile & {
			flex-direction: column;
			gap: rem(20);
		}
	}
}

// 修改卡片样式以匹配figma设计
.lender-card {
	background: linear-gradient(180deg, var(--theme-primary-light) 0%, rgba(255, 255, 255, 0) 50%, rgba(255, 255, 255, 0) 100%);
	border-radius: rem(24);
	border: rem(1) solid #e5e7eb;
	padding: rem(36);
	width: calc((100% - rem(60)) / 3);
	cursor: pointer;
	display: flex;
	flex-direction: column;
	gap: rem(36);

	&:hover {
		border: rem(2) solid #1a4048;
	}

	.detect_deviece_mobile & {
		width: 100%;
		background: linear-gradient(180deg, var(--theme-primary-light) 0%, rgba(255, 255, 255, 0) 50%, rgba(255, 255, 255, 0) 100%);
		border-radius: rem(24);
		padding: rem(24);
		gap: rem(24);
	}
}

.lender-logo-container {
	display: flex;
	flex-direction: row;
	gap: rem(20);
	align-items: center;
	margin-bottom: 0;
}

.lender-logo {
	width: rem(88);
	height: rem(88);
	border-radius: rem(20);
	background: #ffffff;
	border: rem(2) solid var(--theme-primary-light);
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
}

.logo-placeholder {
	width: rem(60);
	height: rem(60);
	border-radius: rem(8);
	background: #cccccc;
}

.lender-info {
	display: flex;
	flex-direction: column;
	gap: rem(16);
}

.lender-name {
	color: #1a4048;
	font-size: rem(24);
	line-height: rem(24);
	font-weight: 800;
	margin-bottom: 0;
}

.lender-rating {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: rem(8);
	background: linear-gradient(270deg, rgba(218, 161, 13, 1) 0%, rgba(246, 195, 63, 1) 100%);
	border-radius: rem(100);
	padding: rem(0) rem(16);
	width: rem(72);
	height: rem(28);

	.star-icon {
		width: rem(12);
		height: rem(12);
		color: #ffffff;
	}

	span {
		color: #ffffff;
		font-size: rem(16);
		line-height: rem(16);
		font-weight: 900;
	}
}

.divider {
	height: rem(1);
	margin: 0;
	background: #e5e7eb;
	align-self: stretch;
}

.lender-details {
	display: flex;
	flex-direction: column;
	gap: rem(24);
}

.detail-item {
	display: flex;
	align-items: flex-start;
	gap: rem(12);
}

.detail-icon {
	width: rem(44);
	height: rem(44);
	border-radius: rem(100);
	background: var(--theme-primary);
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;

	img {
		width: rem(24);
		height: rem(24);
		flex-shrink: 0;
		color: #ffffff;
	}
}

.detail-content {
	display: flex;
	flex-direction: column;
	gap: rem(8);
}

.detail-label {
	color: #1a4048;
	font-size: rem(14);
	line-height: rem(16);
	font-weight: 400;
	margin-bottom: 0;
}

.detail-value {
	color: #1a4048;
	font-size: rem(20);
	line-height: rem(20);
	font-weight: 700;
}
</style>

